import { DocumentAction, DocumentStatus } from '@/schema'

export const mapStatusToAction = (targetStatus: string): DocumentAction => {
  if (targetStatus === DocumentStatus.IN_REVIEW) {
    return DocumentAction.IN_REVIEW
  }
  if (targetStatus === DocumentStatus.APPROVED) {
    return DocumentAction.APPROVED
  }
  if (targetStatus === DocumentStatus.QUERY_RAISED) {
    return DocumentAction.RAISE_QUERY
  }
  if (targetStatus === DocumentStatus.UNDER_REVISION) {
    return DocumentAction.UNDER_REVISION
  }
  return DocumentAction.IN_REVIEW
}
